const initState = {
    isLoading: false,
    data: [],
    error: null,
  };
  
  const DisputeProductsReducer = (state = initState, action) => {
    switch (action.type) {
      case "SET_DISPUTE_PRODUCT_LIST_LOADING":
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      case "SET_DISPUTE_PRODUCT_LIST":
        return {
          ...state,
          isLoading: false,
          data: action.payload,
        };
      case "SET_DISPUTE_PRODUCT_LIST_ERROR":
        return {
          ...state,
          isLoading: false,
          data: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default DisputeProductsReducer;